import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import styles from './styles.module.scss';

const SkeletonProducto = () => (
  <div className={styles.skeletonCard}>
    <Skeleton variant="rounded" className={styles.skeletonImage} />
    <Skeleton variant="text" width="85%" height={24} style={{ marginTop: 10 }} />
    <Skeleton variant="text" width="55%" height={24} />
    <Skeleton variant="text" width="35%" height={30} style={{ marginTop: 6 }} />
  </div>
);

export default SkeletonProducto;
